import React from "react";

//import material ui components
import Paper from "@material-ui/core/Paper";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

//import images, this will not be needed of img URLs come from remote source
import logo from "./images/logo.jpg";
import selector from "./images/selector.jpg";
import luong from "./images/luong.JPG";
import noctex from "./images/noctex.jpg";

export default class Recent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Paper
        elevation={0}
        square={true}
        style={{
          backgroundColor: "orange",
          marginTop: 20
        }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <p />
          <p />
        </div>
        <b>Recent Projects</b>

        <div
          style={{
            marginTop: 20,
            flexDirection: "row",
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap"
          }}
        >
          {cardsData.map(cards => (
            <div>
              <Card style={styles.card}>
                <CardMedia
                  style={styles.media}
                  image={cards.img}
                  title={cards.title}
                />
                <CardContent
                  style={{ display: "flex", flex: 1, flexDirection: "column" }}
                >
                  <Typography gutterBottom variant="headline" component="h2">
                    {cards.title}
                  </Typography>
                  <Typography component="p">{cards.summary}</Typography>
                </CardContent>
                {/*
                <CardActions style={{ justifyContent: "flex-end" }}>
                  <p />
                  <Button size="small" color="primary">
                    Learn More
                  </Button>
                </CardActions>
                */}
              </Card>
            </div>
          ))}
        </div>
      </Paper>
    );
  }
}

const styles = {
  card: {
    maxWidth: 345,
    margin: 15,
    minHeight: 355, //395 with learn more
    marginBottom: 60,
    display: "flex",
    flexDirection: "column",
    flex: 1
  },
  media: {
    height: 0,
    borderBottom: "1px solid",
    paddingTop: "56.25%" // 16:9
  }
};

//this data can be moved to external source, e.g. firebase database
const cardsData = [
  {
    img: luong,
    title: "luong.co",
    summary: "A simple single page website created with Javascript and ReactJS."
  },
  {
    img: selector,
    title: "Microsoft OEM license Selector",
    summary:
      "A microsoft license selector built with ReactJS. Data can be hosted on any noSQL server."
  },
  {
    img: noctex,
    title: "Internet Connected Ballasts",
    summary:
      "Created an Internet connected digital ballasts system using NodeJS on an Orange Pi Zero as a RS485 network hub.  ReactJS/React-Native for the front ends and Firebase as the backend."
  }
];



// WEBPACK FOOTER //
// ./src/recent.js